import Avatar from './src/Avatar'
import AvatarDescription from './src/components/avatar-description/AvatarDescription'
export { AvatarDescription }
export default Avatar
